import * as React from "react";

import { Link } from "react-router-dom";

import { Page, PageInner, PageSection, TooltipWrapper } from "@app/shared";
import { QESButton, WizardNavigationBar, WizardSteps } from "@app/shared/qes-standards";

import cx from "classnames";
import { focusFirstInteractiveElement } from "@app/shared/utility";

interface AccessReportsAdminWizardStepProps {
  children?: React.ReactNode;
  currentWizardStep: number;
  nextPath?: string;
  nextPathDisabled?: boolean;
  nextPathDisabledTooltipText?: string;
  onSaveProductClick?: () => void;
  previousPath?: string;
  setWizardStep: (page: number) => void;
  wizardSteps: string[];
}

class AccessReportsAdminWizardStep extends React.Component<AccessReportsAdminWizardStepProps> {
  private wizardBodyRef = React.createRef<HTMLDivElement>();
  constructor(props: AccessReportsAdminWizardStepProps) {
    super(props);
  }

  public componentDidMount() {
    focusFirstInteractiveElement(this.wizardBodyRef);
  }

  public componentDidUpdate(prevProps: AccessReportsAdminWizardStepProps) {
    if (prevProps.currentWizardStep !== this.props.currentWizardStep) {
      // something's weird with the third step, page options,
      // that causes the focus to start in the middle of the page
      // so I'd rather leave this parameter blank and let it go to the top of the page
      focusFirstInteractiveElement();
    }
  }

  public render() {
    const hasChildren = React.Children.count(this.props.children) > 0;

    return (
      <Page className="bg-white" documentTitle="Access Reports Admin Wizard">
        <PageInner>
          <PageSection>
            <div className="row">
              <div className="col-12">
                <h2 className="mt-3 mb-3 header-l font-weight-bold">
                  Add Product
                </h2>
              </div>
            </div>

            <div className="row">
              <div className="col-10">
                <WizardSteps
                  currentStep={this.props.currentWizardStep}
                  setStep={this.props.setWizardStep}
                  steps={this.props.wizardSteps}
                />
              </div>

              <div className="col-12">
                <hr />
              </div>
            </div>

            <div ref={this.wizardBodyRef}>
              {hasChildren && this.props.children}
            </div>

            <div className="row">
              <div className="col-12">
                <hr />
              </div>
            </div>
          </PageSection>
        </PageInner>
        <WizardNavigationBar
          leftSide={
            <Link
              className="qes-button qes-button-secondary danger"
              id="access-reports-admin__wizard-step--cancel"
              to={{
                pathname: `/access-reports/admin/dashboard`,
              }}
              type="button"
            >
              Cancel
            </Link>
          }
          rightSide={
            <div>
              {this.props.previousPath &&
                <Link
                  id="access-reports-admin__wizard-step--previous"
                  className="qes-button qes-button-secondary"
                  to={{
                    pathname: `${this.props.previousPath}`,
                  }}
                  type="button"
                >
                  Previous
                </Link>
              }

              {this.props.nextPath && (
                <TooltipWrapper
                  text={this.props.nextPathDisabled && this.props.nextPathDisabledTooltipText}
                  position="top"
                >
                  <Link
                    className={cx({
                      "disabled": this.props.nextPathDisabled,
                      "ml-3": true,
                      "qes-button": true,
                      "qes-button-primary": true,
                    })}
                    aria-disabled={this.props.nextPathDisabled}
                    id="access-reports-admin__wizard-step--next"
                    onClick={(e) => e.currentTarget.blur()}
                    to={{
                      pathname: `${this.props.nextPath}`,
                    }}
                    type="button"
                  >
                    Next
                  </Link>
                </TooltipWrapper>
              )}

              {this.props.onSaveProductClick && (
                <TooltipWrapper
                  text={this.props.nextPathDisabled && this.props.nextPathDisabledTooltipText}
                  position="top"
                >
                  <QESButton
                    className="cursor-pointer ml-3"
                    disabled={this.props.nextPathDisabled}
                    onClick={this.props.onSaveProductClick}
                    qesTestId="access-reports-admin__wizard-step--submit"
                    qesType="primary"
                  >
                    Submit
                  </QESButton>
                </TooltipWrapper>
              )}
            </div>
          }
        />
      </Page>
    );
  }
}

export { AccessReportsAdminWizardStep };
